import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { SignupService } from "../services/signup.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";


@Injectable()
export class SignupGuard implements CanActivate {

    constructor(private signupService: SignupService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let url: string = state.url;
        return this.checkSignupSteps(url);
    }

    checkSignupSteps(url: string): boolean {

        switch (url) {
            case "/signup-2":
                if (!this.signupService.isStep1Complete()) {
                    this.router.navigateByUrl('/signup');
                    return false;
                }
                break;
            case "/signup-2-not-suitable":
                if (!this.signupService.isStep2Complete()) {
                    this.router.navigateByUrl('/signup-2');
                    return false;
                }
                break;
            case "/signup-3":
                if (!this.signupService.isStep2Complete()) {
                    this.router.navigateByUrl('/signup-2');
                    return false;
                }
                else {
                    if (!this.signupService.isClientAccessmentAccepted()) {
                        this.router.navigateByUrl('/signup-2-not-suitable');
                        return false;
                    }
                }
                break;
            case "/signup-4":
                if (!this.signupService.isStep3Complete()) {
                    this.router.navigateByUrl('/signup-3');
                    return false;
                }
                break;
        }

        return true;
    }
}